const dev = {
  url:"//localhost:3000/",
  s3Url:"//s3.us-east-1.amazonaws.com/flashcards.infullstack.com/",
  flashcardsadminfe:'//localhost:8081/'
}
const prod = {
  url:"//infullstack.com/flashcards/",
  s3Url:"//infullstack.com/flashcards/",
  flashcardsadminfe:'//flashcardsadminfe.infullstack.com/'
}

const config = process.env.REACT_APP_ENVIRONMENT === 'dev'
  ? dev
  : prod;

export default config;
